import { Pipe, PipeTransform } from '@angular/core';
import { LangService } from '../services/lang.service';

export type I18nLabels = { [lang: string]: string } | null | undefined;

/** Libellé dans la langue demandée, sinon FR, sinon `fallback`. */
export function resolveI18nLabel(labels: I18nLabels, lang: string, fallback?: string): string {
    const value = labels?.[(lang || '').toUpperCase()];
    if (value?.trim()) {
        return value;
    }
    return labels?.['FR']?.trim() ? labels['FR'] : (fallback ?? '');
}

@Pipe({
    name: 'i18nLabel',
    pure: false,
    standalone: false
})
export class I18nLabelPipe implements PipeTransform {

    constructor(private langService: LangService) {
    }

    transform(labels: I18nLabels, fallback?: string): string {
        return resolveI18nLabel(labels, this.langService.currentLang, fallback);
    }
}
